export default "__VITE_ASSET__tB1kmhx5__"